import router from '.'
import { getToken } from '@/utils/auth'

const LOGIN_PATH = '/login' // 登录页面
const HOME_PATH = '/home' // 首页

router.beforeEach((to, from, next) => {
    if(!getToken() && to.path !== LOGIN_PATH) {
        next({ path: LOGIN_PATH })
    } else if (to.path === LOGIN_PATH && getToken()) {
        next({ path: HOME_PATH })
    } else {
        next()
    }
})

